// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ATbN","importantInfo":"styles_importantInfo__2ZOb5"};